import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../redux/hooks';
import { qlistSelector } from '../redux/slices/questionsSlice';
import { AnswerWithQid, Question, User } from '../types';
import { ModelType, rankingTypeSelector, trendTypeSelector } from '../redux/slices/exploreSlice';
import { setHeaderTitle } from '../redux/slices/layoutSlice';
import { ulistSelector } from '../redux/slices/userSlice';

/**
 * Custom hook for managing the explore page state.
 *
 * @returns users - The current full list of users.
 * @returns questions - The current full list of questions.
 * @returns answers - The current full list of answers with their question's IDs.
 * @returns rankingType - The current ranking type that the leaderboard is displaying.
 * @returns trendType - The current trend type that the trending tab is displaying.
 */
const useExplorePage = () => {
  const dispatch = useAppDispatch();

  const questions: Question[] = useAppSelector(qlistSelector) || [];
  const answers: AnswerWithQid[] = [];
  questions.forEach(q => q.answers.forEach(a => answers.push({ ...a, qid: q._id })));
  const users: User[] | undefined = useAppSelector(ulistSelector);
  const rankingType: ModelType = useAppSelector(rankingTypeSelector);
  const trendType: ModelType = useAppSelector(trendTypeSelector);

  useEffect(() => {
    dispatch(setHeaderTitle('Explore'));
  }, [dispatch]);

  return {
    users: users || [],
    questions,
    answers,
    rankingType,
    trendType,
  };
};

export default useExplorePage;
